
const Colors = {
  primary: '#3f4e5c' || '#4791db' || '#4791db' || '#34495E' || '#364150' || '#2B3643' || '#2ECC71' || '#62C36D',
  secondary: '#e33371',
  default: '#707070',
  error: '#F4586C',
  warning: '#F9A000',
  info: '#22C0FA',
  dark: '#222',
  light: '#f2f2f2',
  black: '#000',
  white: '#fff',
  background: '#fff',
  raven: '#7E8591',
  hyperBlox: {
    header: '#486583' || '#34495E',
    backgroundColor: '#f5f5f5',
  },
  dataflow : {
    arrowStroke: "#1c00aa",
    arrowText: "#000",
    arrowLabelBackground: "#ffdf19",
    arrowLabelBorder: "#000",
    nodeType : "#888888",
    nodeLabel :  "#333",
    onsendBox: "#239059",
    onrecvBox: "#b95b2d",
    invokedTxPath : "#757876",
    // nestedTxPath : "#b13fc3",
    nestedTxPath : " #13a8b8", 

  }
};

export default Colors;
